// extracted by mini-css-extract-plugin
export default {"table-bottom-field-container":"QSf4rPjRlDu7f5ruBgTu","left-field-container":"ixxAJzvkljxVHPtVmTYL"};